import { request } from 'umi';

export async function postLogin(body: API.LoginParameters) {
  return request('/auth/login', {
    method: 'post',
    data: new URLSearchParams(body),
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
    },
  });
}

export async function postSmeSignup(body: API.SmeSignupParameters) {
  return request('/smeai/signup', {
    method: 'post',
    data: body,
  });
}

export async function postLogout() {
  return request('/auth/logout', {
    method: 'post',
  });
}

export async function postForgetPassword(data: API.ForgetPasswordPostParameters) {
  return request('/auth/forgot-password', {
    method: 'post',
    data,
  });
}

export async function postResetPassword(data: API.ResetPasswordPostParameters) {
  return request('/auth/reset-password', {
    method: 'post',
    data,
  });
}

export async function postSendVerificationCode(data: API.SendVerificationCodeParameters) {
  return request('/auth/send-verification-code', {
    method: 'post',
    data,
  });
}

export async function postVerifyEmail(data: API.VerifyEmailParameters) {
  return request('/auth/verify-email', {
    method: 'post',
    data,
  });
}

export async function postResendVerification(data: API.ResendVerificationParameters) {
  return request('/auth/resend-verification', {
    method: 'post',
    data,
  });
}

export async function postRegister(data: API.RegisterWithVerificationParameters) {
  return request('/auth/register', {
    method: 'post',
    data,
  });
}
